import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/main.scss';
 import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";
import Signin from './pages/auth/signin';
import Signup from './pages/auth/signup';
import NeonPage from './pages/neon';
import TeamPage from './pages/team';
import MessengerPage from './pages/messenger';
import SupportPage from './pages/support';
import { NotFound } from './pages/notfound';
import PickAvatar from './pages/pick-avatar';
// import './assets/fonts/inter/inter.css';

const router = createBrowserRouter([
  {
    path: "/choose",
    element: (
      <div>
        <h1 className='text-3xl font-medium'>Hello World</h1>
        <Link to="messenger">Messenger</Link>
        <Link to="team">Team</Link>
        <Link to="neon">Neon</Link>
        <Link to="about">About Us</Link>
      </div>
    ),
  },
  {
    path: "*",
    element: <NotFound/>
  },
  {
    path: "/",
    element: <App/>
  },
  {
    path: "auth/signin",
    element: <Signin/>
  },
  {
    path: "auth/signup",
    element: <Signup/>
  },
  {
    path: "pick-avatar",
    element: <PickAvatar/>
  },
  {
    path: "/chat/team",
    element: <TeamPage dark />
  },
  {
    path: "/chat/neon",
    element: <NeonPage dark />
  },
  {
    path: "/chat/messenger",
    element: <MessengerPage dark />
  },
  {
    path: "/chat/support",
    element: <SupportPage dark />
  },
  {
    path: "/chat/team/light",
    element: <TeamPage light />
  },
  {
    path: "/chat/neon/light",
    element: <NeonPage light />
  },
  {
    path: "/chat/messenger/light",
    element: <MessengerPage light />
  },
  {
    path: "/chat/support/light",
    element: <SupportPage light />
  }
]);

createRoot(document.getElementById("root")).render(
    <RouterProvider router={router} />
);



// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );// 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
